import React from "react";
import "./styles.css";

const Title = (props: any) => {
    return <h1 className="title"> ProSif - {props.subtitle} </h1>;
};

export default Title;
